import styled, { css } from 'styled-components'

export const StyledIframe = styled.iframe<{ minHeight?: number; indent: number }>`
	width: 100%;
	height: ${({ indent }) => `calc(100vh - ${indent}px)`};
	min-height: ${({ indent }) => `${200 + indent}px)`};
	${({ minHeight, indent }) =>
		minHeight &&
		css`
			height: max(100vh - ${indent}px, 100%);
			min-height: min(100vh - ${indent}px, ${minHeight}px);
		`}
`
